module.exports = __webpack_public_path__ + "img/red_048.c923b790.png";